var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M200.8,496c-3.5-2.3-7.5-4.1-10.5-7c-4.9-4.5-5.4-10.9-5.4-17.2c0-58.1-0.1-116.2,0.1-174.3 c0.1-13.6-3.7-25.4-11.6-36.4C121.4,188.2,69.7,115.3,18,42.4c-7-9.8-7.5-18.8-1.7-26.9C20,10.2,25.3,7.6,31.6,7 c1.6-0.2,3.2-0.1,4.8-0.1c143,0,285.9,0,428.9,0c12.7,0,20.3,5.1,23.2,15.6c2,7.4-0.7,13.7-4.9,19.6 c-23.8,33.5-47.5,66.9-71.3,100.4c-28.3,39.8-56.4,79.7-84.9,119.4c-7.5,10.5-11.1,21.8-11,34.7c0.2,47,0.1,93.9,0.1,140.9 c0,13.7-3.5,18.8-16.3,23.6c-30,11.4-60,22.7-90,34.1c-0.3,0.1-0.5,0.4-0.7,0.6C206.5,496,203.7,496,200.8,496z M41.2,31.9 c1.3,1.9,2.1,3.2,3,4.5c49.7,70,99.4,140.1,149.3,210.1c10.9,15.3,16.4,31.8,16.3,50.7c-0.3,55.2-0.1,110.4-0.1,165.7 c0,1.8,0,3.6,0,6c2.3-0.7,3.8-1.1,5.2-1.7c24-9.2,48.1-18.4,72.2-27.4c3.6-1.4,4.7-3.1,4.7-6.8c-0.1-45.4,0-90.7-0.2-136.1 c-0.1-18.3,5.1-34.5,15.7-49.5c50-70.2,99.9-140.5,149.8-210.9c1-1.4,1.8-2.8,3-4.6C320.3,31.9,181.1,31.9,41.2,31.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.4ba8602816020d7e7c30400c3c91e26a.svg";
export { ForwardRef as ReactComponent };